"use client";

import { useAuthActions } from "@convex-dev/auth/react";
import { api } from "@smart-polling/backend/convex/_generated/api";
import { useQuery } from "convex/react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { ModeToggle } from "./mode-toggle";
import { Button } from "./ui/button";

export default function Header() {
  const { signOut } = useAuthActions();
  const router = useRouter();
  const currentUser = useQuery(api.users.current);
  console.log("currentUser", currentUser);
  const links = [
    { to: "/", label: "Smart Polling" },
    { to: "/polls/create", label: "Create" },
    { to: "/explore", label: "Explore" },
    { to: "/my-polls", label: "My Polls" },
  ];

  return (
    <header className="sticky top-0 z-50 border-border border-b bg-card text-card-foreground">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
        <nav className="flex gap-4 text-lg">
          {links.map(({ to, label }) => {
            return (
              <Link key={to} href={to}>
                {label}
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-2">
          <ModeToggle />
          {currentUser === undefined ? null : currentUser && !currentUser.isAnonymous ? (
            <>
              <span className="text-muted-foreground text-sm">{currentUser.email ?? "Signed in"}</span>
              <Button
                type="button"
                onClick={async () => {
                  await signOut();
                  router.refresh();
                }}
              >
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Link href="/auth/sign-in" className="text-sm underline">
                Sign in
              </Link>
              <Link href="/auth/sign-up" className="text-sm underline">
                Sign up
              </Link>
            </>
          )}
        </div>
      </div>
      <hr />
    </header>
  );
}
